export const AUdollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'AUD',
});